'use client';

import { FC, PropsWithChildren, useMemo } from 'react';

import { TranslationsContext } from '../contexts/translations-context';
import { NestedTranslations } from '../models/nested-translations.model';

interface Props extends PropsWithChildren {
   locale: string;
   translations: NestedTranslations | null;
   fallback: NestedTranslations | null;
}

export const TranslationsContextProvider: FC<Props> = ({ locale, translations, fallback, children }) => {
   const value = useMemo(() => ({ locale, translations, fallback }), [locale, translations, fallback]);

   return <TranslationsContext.Provider value={value}>{children}</TranslationsContext.Provider>;
};
